module.exports = __webpack_public_path__ + "static/media/Staravia_gaussian2.9b75a553.png";